import React from 'react'
import { useTranslation } from 'react-i18next'
import { MegaTagTitle } from '@/components/Elements'
import { PasswordContainer } from '@/features/profile/components/Profile'

export const Security = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'confidential_info_settings'} />

      <PasswordContainer />
    </>
  )
}
